import {
  DoneAllRounded,
  EditRounded,
  LocalShippingRounded,
  PaymentsRounded,
  RemoveRedEyeRounded,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { action, API, controller } from "../../../../api/api";
import { AppContext } from "App";

const Actions = ({ setAlert, setStocks, param }) => {
  const { access } = useContext(AppContext);
  const navigate = useNavigate();

  const handleAddEdit = (id) => {
    navigate(`/order_stock_form/${id || ""}`);
  };

  const handleViewOrder = (id) => {
    navigate(`/view_order/${id}`);
  };

  const handleMarkAsSent = (val) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: `You’re about to change the order "${val.orderNum}" to sent`,
      subTitle:
        "You’ll be able to see which orders have already been sent to suppliers. If you need to make changes after hearing back from your supplier, you can edit your sent order. This action cannot be undone.",
      confirmBtnTitle: "Change status to sent",
      onConfirm: () => {
        API(controller.Stock + action.MarkStatusAsSent).getById(
          val.id,
          (res) => {
            if (res && res.result && res.status === 200) {
              setStocks((j) =>
                j.map((x) => (x.id === res.result.id ? res.result : x))
              );
              setAlert({
                isOpen: true,
                type: "success",
                title: "Success",
                subTitle: res.msg,
              });
            } else
              setAlert({
                isOpen: true,
                type: "error",
                title: "Error",
                subTitle: res.msg,
              });
          }
        );
      },
    });
  };

  const handleReceived = (id) => {
    navigate(`/receive_delivery_form/${id}`);
  };

  const handlePayBalance = (supplierId) => {
    navigate(`/view_supplier/${supplierId}`);
  };

  return (
    <div className="border !border-slate-200 shadow-md rounded-[8px] w-fit flex gap-3 p-[2px]">
      <Tooltip title="View">
        <IconButton
          onClick={() => handleViewOrder(param.id)}
          size="small"
          color="primary"
          className="ml-[5px] mr-[5px] p-[5px]"
        >
          <RemoveRedEyeRounded className="!text-[18px] m-[2px]" />
        </IconButton>
      </Tooltip>
      {access?.stock?.payment && param.paymentStatus === 1 && (
        <Tooltip title="Pay balance/Due Amount">
          <IconButton
            onClick={() => handlePayBalance(param.splrId)}
            size="small"
            color="primary"
            className="ml-[5px] mr-[5px] p-[5px]"
          >
            <PaymentsRounded className="!text-[18px] m-[2px]" />
          </IconButton>
        </Tooltip>
      )}
      {param.status !== 3 && param.status !== 2 && (
        <>
          {access?.stock?.edit && (
            <Tooltip title="Edit">
              <IconButton
                onClick={() => handleAddEdit(param.id)}
                size="small"
                color="primary"
                className="mr-[5px] p-[5px]"
              >
                <EditRounded className="!text-[18px] m-[2px]" />
              </IconButton>
            </Tooltip>
          )}
          {access?.stock?.status && (
            <Tooltip title="Receive">
              <IconButton
                onClick={() => handleReceived(param.id)}
                size="small"
                color="primary"
                className="mr-[5px] p-[5px]"
              >
                <DoneAllRounded className="!text-[18px] m-[2px]" />
              </IconButton>
            </Tooltip>
          )}
          {access?.stock?.status && param.status !== 4 && (
            <Tooltip title="Mark as Sent">
              <IconButton
                onClick={() => handleMarkAsSent(param)}
                size="small"
                color="primary"
                className="mr-[5px] p-[5px]"
              >
                <LocalShippingRounded className="!text-[18px] m-[2px]" />
              </IconButton>
            </Tooltip>
          )}
        </>
      )}
    </div>
  );
};

export default Actions;
